(function () {
  'use strict';

  document.querySelectorAll('.book-shelf').forEach(function (shelf) {
    var grid = shelf.querySelector('.book-shelf-grid');
    var prev = shelf.querySelector('.book-shelf-arrow--prev');
    var next = shelf.querySelector('.book-shelf-arrow--next');
    if (!grid || !prev || !next) return;

    var scrollStep = 540; // ~3 cards (160px + 20px gap each)

    function updateArrows() {
      prev.disabled = grid.scrollLeft <= 0;
      next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
    }

    prev.addEventListener('click', function () {
      grid.scrollBy({ left: -scrollStep, behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      grid.scrollBy({ left: scrollStep, behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });
})();
